export const S = {usuario:null, vista:'panel', contrato:null, tab:'resumen', modal:null,
           filtro:'todos', filtroPed:'todos', filtroPedContrato:'todos', tipoDoc:'todos',
           filtroImpContrato:'todos', filtroImpCarretera:'todos', impDesde:'', impHasta:'', impOrden:'fecha', impOrdenDir:'desc',
           infContrato:'todos', infCarretera:'todos', infDesde:'', infHasta:'', filtroCertContrato:'todos'};
